import { AboutHighlight, AboutText, AboutWrapper } from "./styles";

/**
 * Texto institucional exibido ao final da página de alertas, antes do rodapé.
 */
export const AboutVoopter = () => (
  <AboutWrapper>
    <AboutText>
      O Voopter combina tecnologia e análise de dados para simplificar a compra
      de passagens aéreas. A plataforma acompanha a oscilação de preços,
      encontra promoções e indica o melhor momento para comprar,{" "}
      <AboutHighlight>
        ajudando você a tomar decisões mais inteligentes e econômicas.
      </AboutHighlight>
    </AboutText>
  </AboutWrapper>
);

export default AboutVoopter;
